function setupHomeSlider() {
	let sliderElement = document.querySelector(".swiper");
	if (!sliderElement) return; // Exit if the slider does not exist

	let homePageSlider = new Swiper(sliderElement, {
		pagination: {
			el: ".swiper-pagination",
			clickable: false,
		},
		a11y: {
            containerMessage: "This is a slide show. Use the tab key to navigate.",
			prevSlideMessage: "Previous slide",
			nextSlideMessage: "Next slide",
		},
	});

	const prevButton = document.querySelector(".slide-arrow.prev");
	if (prevButton) {
		prevButton.addEventListener("click", () => {
			homePageSlider.slidePrev();
		});
		prevButton.addEventListener("keydown", overrideKeydownHandler);
		prevButton.addEventListener("keyup", overrideKeyupHandler);
	}

	const nextButton = document.querySelector(".slide-arrow.next");
	if (nextButton) {
		nextButton.addEventListener("click", () => {
			homePageSlider.slideNext();
		});
		nextButton.addEventListener("keydown", overrideKeydownHandler);
		nextButton.addEventListener("keyup", overrideKeyupHandler);
	}

	// If spacebar or enter is pressed, click it!
	function overrideKeydownHandler(event) {
		if (event.keyCode === 32 || event.keyCode === 13) {
			event.preventDefault();
			if (event.target.tagName === "A") {
				event.target.click();
			} else {
				this.click();
			}
		}
	}

	// If the spacebar is pressed, don't scroll the page
	function overrideKeyupHandler(event) {
		if (event.keyCode === 32) {
			event.preventDefault();
		}
	}

	const swiperButtons = document.querySelectorAll(".swiper-button");
	if (swiperButtons.length > 0) {
		homePageSlider.on("slideChange", function() {
			updateButtonColors(homePageSlider);
		});
	}

	function updateButtonColors(swiperInstance) {
		const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
		if (!activeSlide) return; // Check if the active slide exists

		const buttonInSlide = activeSlide.querySelector(".button");
		if (buttonInSlide) {
			const buttonBgColor = window.getComputedStyle(buttonInSlide)
				.backgroundColor;

			swiperButtons.forEach((swiperButton) => {
				swiperButton.style.backgroundColor = buttonBgColor;
			});
		}
	}

	// Initial update in case the first slide has a unique color
	updateButtonColors(homePageSlider);
}

setupHomeSlider();
